module.exports = __webpack_public_path__ + "media/audio36.05215765.mp3";